import { useState } from 'react'

export type ConsentState = 'undecided' | 'accepted' | 'rejected'

const STORAGE_KEY = 'gssnhr_cookie_consent'

export const useCookieConsent = () => {
    const [consent, setConsent] = useState<ConsentState>(() => {
        try {
            const stored = localStorage.getItem(STORAGE_KEY)
            if (stored === 'accepted' || stored === 'rejected') return stored
        } catch (_) {}
        return 'undecided'
    })

    const accept = () => {
        try {
            localStorage.setItem(STORAGE_KEY, 'accepted')
        } catch (_) {}
        setConsent('accepted')
    }

    const reject = () => {
        try {
            localStorage.setItem(STORAGE_KEY, 'rejected')
        } catch (_) {}
        setConsent('rejected')
    }

    const analyticsAllowed = consent === 'accepted'
    const showBanner = consent === 'undecided'

    return { consent, accept, reject, analyticsAllowed, showBanner }
}
